import { Map as ImmutableMap, Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { OBJECT_PROPERTY } from 'automation-ui-formula-editor/formula-editor/data-passing/constants/DataSourceOptions';
import * as StaticBranchActionMetadataKeys from 'automation-ui-action-features/actions/static-branch/StaticBranchActionMetadataKeys';
import StaticBranchInput from 'automation-ui-action-features/actions/static-branch/StaticBranchInput';
export default class StaticBranchActionMetadata extends Record({
  [StaticBranchActionMetadataKeys.ACTION_TYPE]: ActionTypes.STATIC_BRANCH,
  [StaticBranchActionMetadataKeys.INPUT_TYPE]: OBJECT_PROPERTY,
  [StaticBranchActionMetadataKeys.INPUT_VALUE]: new StaticBranchInput({})
}, 'StaticBranchActionMetadata') {
  constructor(options) {
    let optionMap = ImmutableMap(options);
    const inputValue = optionMap.get(StaticBranchActionMetadataKeys.INPUT_VALUE);
    if (inputValue) {
      optionMap = optionMap.set(StaticBranchActionMetadataKeys.INPUT_TYPE, inputValue.type).set(StaticBranchActionMetadataKeys.INPUT_VALUE, new StaticBranchInput(inputValue));
    }
    super(optionMap);
  }
  getInputType() {
    return this.get(StaticBranchActionMetadataKeys.INPUT_TYPE);
  }
  getInputValue() {
    return this.get(StaticBranchActionMetadataKeys.INPUT_VALUE);
  }
  getValueIdentifierDataKey() {
    const identifier = this.getInputValue().getIdentifier();
    return identifier ? identifier.getDataKey() : null;
  }
  getValueIdentifierActionId() {
    const identifier = this.getInputValue().getIdentifier();
    return identifier ? identifier.getActionId() : null;
  }
}